import React from 'react';
import styles from './RelationshipDetail.module.scss';

function RelationshipDetail({ header = 'Relationship Name', name }) {
    return (
        <>
            <div className={styles['relationship-container']}>
                <div className={styles['relationship-header']}>
                    {header}
                </div>
                <div className={styles['relationship-content']}>
                    <div>{name}</div>
                </div>
            </div>
        </>
    );
}
export default RelationshipDetail;
